import {
  _PluginCustomEvent,
  _PluginCustomEventSchema,
} from "../../../../dtos/analytics-events/custom-events";

export const PluginCustomEventSchema2024_05_05 = _PluginCustomEventSchema;
export type PluginCustomEvent2024_05_05 = _PluginCustomEvent;
